import React from "react";
import { Modal } from "react-bootstrap";

interface IProps {
    show: boolean;
    onHideHandler?: () => void;
    closeOnOutClick?: boolean;
    className?: string;
    bodyClassName?: string;
    footerClassName?: string;
    color?: "red";
    centered?: boolean;
    bodyLeft?: boolean;
    title?: JSX.Element | string;
    body: JSX.Element | string;
    footer?: JSX.Element;
    size?: "sm" | "lg" | "xl" | undefined;
    classNameCenter?: string;
    scrollable?: boolean;
}

class BaseModal extends React.Component<IProps> {
    private getColor = (): string => {
        switch (this.props.color) {
            case "red":
                return "modal-danger";
            default:
                return "";
        }
    };

    public render(): JSX.Element {
        const {
            show,
            onHideHandler,
            closeOnOutClick,
            centered,
            className,
            bodyClassName,
            footerClassName,
            title,
            body,
            footer,
            size,
            bodyLeft,
            classNameCenter,
            scrollable,
        } = this.props;

        return (
            <Modal
                show={show}
                onHide={onHideHandler}
                size={size}
                centered={centered}
                backdrop={closeOnOutClick === false ? "static" : true}
                dialogClassName={[className, this.getColor()].join(" ")}
                contentClassName={classNameCenter + " py-2"}
                scrollable={scrollable}
            >
                <Modal.Body className={bodyClassName}>
                    <h4 className={`cq-text-blue text-center mb-4`}>{title}</h4>
                    <div className={`text-ccq-default${!bodyLeft ? " text-center" : ""}`}>{body}</div>
                </Modal.Body>
                {footer ? (
                    <Modal.Footer className={["border-0 d-flex justify-content-center", footerClassName].join(" ")}>
                        {footer}
                    </Modal.Footer>
                ) : null}
            </Modal>
        );
    }
}

export { BaseModal as Unconnected };
export default BaseModal;
